import styled, { css } from 'styled-components';
import { getSchemaState, getWhiteColor } from '../../../foundation/theme/palette.utils';
import { getShadow } from '../../../foundation/theme/shape.utils';
import { getRadius, getSpace } from '../../../foundation/theme/space.utils';
// styled-components.
// -----------------------------------------------------------------------------
export const KanbanRoot = styled.div `
  // Display and Box
  display: grid;
  grid-auto-columns: max-content;
  grid-auto-flow: column;
  grid-auto-rows: 1fr;
  grid-gap: ${getSpace('s')};

  // Spacing
  padding: ${getSpace('s')};

  // Other
  border-radius: ${getRadius('m')};
  min-height: 800px;
  overflow: auto;
`;
export const KanbanCluster = styled.div `
  display: flex;
  flex-direction: column;
`;
export const KanbanClusterTitle = styled.div `
  // Display and box
  align-items: center;
  display: flex;
  gap: ${getSpace('s')};

  // Spacing
  padding: 0 ${getSpace('s')};

  // Color
  ${({ theme, variant, mode }) => {
    const { background } = getSchemaState({
        variant: 'hard',
        schema: variant,
        state: 'default',
        theme,
        mode
    });
    return css `
      svg {
        color: ${background};
      }
    `;
}}
`;
export const KanbanClusterContent = styled.div `
  // Display and box
  display: grid;
  flex: 1 1 auto;
  grid-auto-columns: max-content;
  grid-auto-flow: column;
  grid-auto-rows: 1fr;
  grid-gap: ${getSpace('s')};

  // Spacing
  padding: ${getSpace('s')};

  // Other
  border-radius: ${getRadius('m')};

  // Color
  ${({ theme, variant, mode }) => {
    const { background } = getSchemaState({
        variant: 'soft',
        schema: variant,
        state: 'default',
        theme,
        mode
    });
    return css `
      background-color: ${background};
    `;
}}
`;
export const KanbanColumn = styled.div `
  display: flex;
  flex-direction: column;
`;
export const KanbanColumnContent = styled.div `
  display: grid;
  grid-gap: ${getSpace('s')};
  flex: 1 1 auto;

  ${({ columnSize }) => {
    return css `
      grid-auto-columns: ${columnSize};
    `;
}}
`;
export const KanbanTile = styled.div `
  background: #f4f5f7bd;
  border-radius: ${getRadius('m')};
`;
export const KanbanTileTitle = styled.div `
  // Display and box
  align-items: center;
  display: flex;
  gap: ${getSpace('s')};

  // Spacing
  padding: ${getSpace('s')} ${getSpace('m')} 0 ${getSpace('m')};

  // Color
  color: #565656;

  svg {
    color: #999;
  }
`;
export const KanbanTileContent = styled.div `
  // Display and box
  display: flex;
  gap: ${getSpace('s')};
  flex-direction: column;

  // Spacing
  padding: ${getSpace('s')};
`;
export const KanbanCard = styled.div `
  // Spacing
  padding: ${getSpace('m')};

  // Color
  background: ${getWhiteColor()};

  // Other
  border: 1px solid #ddd;
  border-radius: ${getRadius('m')};

  ${({ theme, mode }) => {
    return css `
      box-shadow: ${getShadow({
        theme,
        mode,
        variant: 's'
    })};
    `;
}}
`;
//# sourceMappingURL=Kanban.styled.js.map